import React from 'react'
import Photo from "../../../../Assests/Products/Hospitalmang/Inventory.png"
const  Compliance = () => {
    return (
        <div className='HosAnalysis'>
            <div className="HosAnalysis-Photo" data-aos="zoom-in-right">
                <img src={Photo} alt='' />
            </div>
            <div className="HosAnalysis-Def" data-aos="zoom-in-right">
                <h2>
                    Compliance with Standards:
                </h2>
                <p>
                    The system is designed to help laboratories comply with necessary regulations and industry standards, streamlining quality assurance and minimizing risks associated with regulatory non-compliance.
                </p>

            </div>
        </div>
    )
}

export default Compliance



